import { render, staticRenderFns } from "./happy-space-detail.vue?vue&type=template&id=e92c0d24&scoped=true&"
import script from "./happy-space-detail.vue?vue&type=script&lang=js&"
export * from "./happy-space-detail.vue?vue&type=script&lang=js&"
import style0 from "./happy-space-detail.vue?vue&type=style&index=0&id=e92c0d24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e92c0d24",
  null
  
)

export default component.exports